import { connect } from 'react-redux';
import { designNotesEditorSelector } from '../../../../../../../../redux/product/product.selectors';
import { designNotesDispatcher } from '../../../../../../../../redux/product/product.dispatchers';
import { DesignNoteComponent } from './design-note';
export const DesignNote = connect(designNotesEditorSelector, designNotesDispatcher)(DesignNoteComponent);